import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    IconButton,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useAddCustomerMutation } from "../../store/services/customerService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import colors from "../../styles/colors";

const labelStyle = {
    fontFamily: "PSBo",
    fontSize: 15,
    color: "#333",
    mb: 0.5,
};

const AddCustomerDialog = ({ open, onClose }) => {
    const words = useSelector((state) => state.authReducer.words);

    const [clientType, setClientType] = useState("Individual");
    const [formValues, setFormValues] = useState({
        idNumber: "",
        licenseNumber: "",
        fullName: "",
        address: "",
        phone: "",
        email: "",
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [addCustomer, { isLoading }] = useAddCustomerMutation();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // && file.type === "image/png"
        if (file ) {
            setSelectedFile(file);
        } else {
            toast.error("Please upload a valid PNG file.");
        }
    };

    const handleSubmit = async () => {
        if (!formValues.fullName || !formValues.email || !formValues.phone || !formValues.licenseNumber) {
            toast.error("Please fill in all required fields.");
            return;
        }

        const formData = new FormData();
        formData.append("name", formValues.fullName);
        formData.append("email", formValues.email);
        formData.append("phone", formValues.phone);
        formData.append("id_no", formValues.idNumber);
        formData.append("license_no", formValues.licenseNumber);
        formData.append("address", formValues.address);
        formData.append("type", clientType);


        if (selectedFile) {
            formData.append("image", selectedFile);
        }

        try {
            const response = await addCustomer(formData).unwrap();
            if (response.status === "1") {
                toast.success("Customer added successfully!");
                onClose(); // Close the dialog on success
            } else {
                toast.error("Failed to add customer. Please try again.");
            }
        } catch (error) {
            console.error("Error adding customer:", error);
            toast.error("An error occurred. Please try again.");
        }
    };

    return (
        <>



            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <Loader open={isLoading} />

                <DialogTitle sx={{ fontFamily: "PSBo", fontSize: 18, color: "#333" }}>
                    Add Customer
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} display="flex" flexDirection="row" justifyContent="space-between">
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                                <Box
                                    sx={{
                                        width: "95px",
                                        height: "95px",
                                        borderRadius: "50px",
                                        border: "1px dashed #ccc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        textAlign: "center",
                                        color: "#999",
                                        backgroundColor: "#E6E6E6",
                                        cursor: "pointer",
                                        position: "relative",
                                    }}
                                    onClick={() => document.getElementById("profileImageUpload").click()} // Triggers the hidden input
                                >
                                    {selectedFile ? (
                                        <img
                                            src={URL.createObjectURL(selectedFile)} // Display the uploaded image preview
                                            alt="Profile Preview"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M34.4502 9.85458C33.8158 9.72808 33.2963 9.33133 33.028 8.76399C30.0572 2.49458 23.1706 -1.01101 16.2878 0.257828C10.0165 1.40783 5.10025 6.41416 4.05183 12.7181C3.74133 14.5792 3.76433 16.4422 4.11508 18.2572C4.23008 18.8495 3.97517 19.5088 3.45192 19.9842C1.25733 21.9794 0 24.8218 0 27.785C0 33.5963 4.72842 38.3267 10.5417 38.3267H31.625C39.5523 38.3267 46 31.879 46 23.9517C46 17.1187 41.1432 11.1886 34.4502 9.85458ZM31.625 34.4914H10.5417C6.8425 34.4914 3.83333 31.4822 3.83333 27.7831C3.83333 25.899 4.6345 24.0877 6.02983 22.8189C7.53633 21.4485 8.24358 19.4207 7.87558 17.5232C7.61108 16.1585 7.59575 14.7536 7.82958 13.3429C8.602 8.70074 12.3625 4.86933 16.974 4.02408C17.7119 3.88991 18.446 3.82474 19.1705 3.82474C23.6018 3.82474 27.6134 6.29533 29.5627 10.4066C30.3542 12.0779 31.8627 13.2471 33.6988 13.6132C38.6055 14.5926 42.1647 18.9396 42.1647 23.9517C42.1647 29.763 37.4344 34.4933 31.6231 34.4933L31.625 34.4914ZM28.9819 19.7197C29.7313 20.4691 29.7313 21.6804 28.9819 22.4298C28.6082 22.8036 28.1175 22.9914 27.6268 22.9914C27.1362 22.9914 26.6455 22.8036 26.2717 22.4298L23 19.1581V28.7414C23 29.8013 22.1413 30.6581 21.0833 30.6581C20.0253 30.6581 19.1667 29.8013 19.1667 28.7414V19.1581L15.8949 22.4298C15.1455 23.1792 13.9342 23.1792 13.1848 22.4298C12.4353 21.6804 12.4353 20.4691 13.1848 19.7197L18.3732 14.5312C19.113 13.7914 20.0847 13.4196 21.0565 13.4138L21.0833 13.4081L21.1102 13.4138C22.0838 13.4196 23.0537 13.7914 23.7935 14.5312L28.9819 19.7197Z"
                                                fill="#C5C5C5"
                                            />
                                        </svg>
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        ml: 1,
                                    }}
                                >
                                    <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                        Upload the Image
                                    </Typography>
                                    <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                        150x150 pixel
                                    </Typography>
                                </Box>
                            </Box>

                            <input
                                type="file"
                                id="profileImageUpload"
                                accept=".png,.jpg,.jpeg,"

                                // accept="image/png"
                                onChange={handleFileChange}
                                style={{ display: "none" }} // Hidden file input
                            />

                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["ID Number"]}*</Typography>
                            <TextField
                                fullWidth
                                name="idNumber"
                                value={formValues.idNumber}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Full Name"]}*</Typography>
                            <TextField
                                fullWidth
                                name="fullName"
                                value={formValues.fullName}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Phone"]}*</Typography>
                            <TextField
                                fullWidth
                                name="phone"
                                value={formValues.phone}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Email"]}*</Typography>
                            <TextField
                                fullWidth
                                name="email"
                                value={formValues.email}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["License no"]}*</Typography>
                            <TextField
                                fullWidth
                                name="licenseNumber"
                                value={formValues.licenseNumber}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Client type"]}</Typography>
                            <RadioGroup
                                row
                                value={clientType}
                                onChange={(e) => setClientType(e.target.value)}
                                sx={{ display: "flex", gap: 2 }}
                            >
                                <FormControlLabel
                                    value="Individual"
                                    control={<Radio />}
                                    label={words["Individual"]}
                                />
                                <FormControlLabel
                                    value="Company"
                                    control={<Radio />}
                                    label={words["Company"]}
                                />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography sx={labelStyle}>{words["Adress"]}*</Typography>
                            <TextField
                                fullWidth
                                name="address"
                                value={formValues.address}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={{
                            borderRadius: "20px",
                            fontSize: 12,
                            padding: "8px 16px",
                            textTransform: "none",
                            fontFamily: 'PMe'
                        }}
                    >
                        {words["Cancel"]}
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={isLoading}
                        sx={{
                            backgroundColor: colors.primary,
                            fontSize: 12,
                            color: "white",
                            borderRadius: "20px",
                            padding: "8px 26px",
                            textTransform: "none",
                            fontFamily: 'PMe'
                        }}
                    >
                        {isLoading ? "Submitting..." : words["Submit"]}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AddCustomerDialog;



// import React, { useState } from 'react';
// import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, IconButton, Typography, RadioGroup, FormControlLabel, Radio, Paper } from '@mui/material';
// import { Close, UploadFile } from '@mui/icons-material';
// import colors from '../../styles/colors';
// import { useSelector } from 'react-redux';



// const labelStyle = {
//     fontFamily: 'PSBo',
//     fontSize: 15,
//     color: colors.text,
//     mb: 0.5
// }


// const AddCustomerDialog = ({ open, onClose }) => {

//     const words = useSelector((state) => state.authReducer.words);
//     const [clientType, setClientType] = useState('Individual');

//     const [formValues, setFormValues] = useState({
//         idNumber: '',
//         licenseNumber: '',
//         fullName: '',
//         address: '',
//         phone: '',
//         email: '',

//     });

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormValues({
//             ...formValues,
//             [name]: value,
//         });
//     };


//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//             <DialogTitle sx={{ fontFamily: 'PSBo', fontSize: 18, color: colors.text }} >
//                 Add Customer
//                 <IconButton
//                     aria-label="close"
//                     onClick={onClose}
//                     sx={{
//                         position: 'absolute',
//                         right: 8,
//                         top: 8,
//                         color: (theme) => theme.palette.grey[500],
//                     }}
//                 >
//                     <Close />
//                 </IconButton>
//             </DialogTitle>
//             <DialogContent>
//                 <Grid container spacing={2}>
//                     {/* Profile Image Upload */}
//                     <Grid flexDirection={"row"} justifyContent={"space-between"} display={"flex"} item xs={12} sm={12}>
//                         <Box sx={{ display: 'flex', flexDirection: 'row' }}>
//                             <Box
//                                 sx={{
//                                     width: '95px',
//                                     height: '95px',
//                                     borderRadius: '50px',
//                                     border: '0px dashed #ccc',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     flexDirection: 'column',
//                                     textAlign: 'center',
//                                     color: '#999',
//                                     backgroundColor: "#E6E6E6"

//                                 }}
//                             >
//                                 <svg width="46" height="39" viewBox="0 0 46 39" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                     <path d="M34.4502 9.85458C33.8158 9.72808 33.2963 9.33133 33.028 8.76399C30.0572 2.49458 23.1706 -1.01101 16.2878 0.257828C10.0165 1.40783 5.10025 6.41416 4.05183 12.7181C3.74133 14.5792 3.76433 16.4422 4.11508 18.2572C4.23008 18.8495 3.97517 19.5088 3.45192 19.9842C1.25733 21.9794 0 24.8218 0 27.785C0 33.5963 4.72842 38.3267 10.5417 38.3267H31.625C39.5523 38.3267 46 31.879 46 23.9517C46 17.1187 41.1432 11.1886 34.4502 9.85458ZM31.625 34.4914H10.5417C6.8425 34.4914 3.83333 31.4822 3.83333 27.7831C3.83333 25.899 4.6345 24.0877 6.02983 22.8189C7.53633 21.4485 8.24358 19.4207 7.87558 17.5232C7.61108 16.1585 7.59575 14.7536 7.82958 13.3429C8.602 8.70074 12.3625 4.86933 16.974 4.02408C17.7119 3.88991 18.446 3.82474 19.1705 3.82474C23.6018 3.82474 27.6134 6.29533 29.5627 10.4066C30.3542 12.0779 31.8627 13.2471 33.6988 13.6132C38.6055 14.5926 42.1647 18.9396 42.1647 23.9517C42.1647 29.763 37.4344 34.4933 31.6231 34.4933L31.625 34.4914ZM28.9819 19.7197C29.7313 20.4691 29.7313 21.6804 28.9819 22.4298C28.6082 22.8036 28.1175 22.9914 27.6268 22.9914C27.1362 22.9914 26.6455 22.8036 26.2717 22.4298L23 19.1581V28.7414C23 29.8013 22.1413 30.6581 21.0833 30.6581C20.0253 30.6581 19.1667 29.8013 19.1667 28.7414V19.1581L15.8949 22.4298C15.1455 23.1792 13.9342 23.1792 13.1848 22.4298C12.4353 21.6804 12.4353 20.4691 13.1848 19.7197L18.3732 14.5312C19.113 13.7914 20.0847 13.4196 21.0565 13.4138L21.0833 13.4081L21.1102 13.4138C22.0838 13.4196 23.0537 13.7914 23.7935 14.5312L28.9819 19.7197Z" fill="#C5C5C5" />
//                                 </svg>

//                             </Box>
//                             <Box
//                                 sx={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     flexDirection: 'column',
//                                     ml: 1

//                                 }}
//                             >
//                                 <Typography sx={{ fontFamily: 'PMe', fontSize: 14, color: colors.dimText }} >Upload the Image</Typography>
//                                 <Typography sx={{ fontFamily: 'PMe', fontSize: 14, color: colors.dimText }} >150x150 pixel</Typography>
//                             </Box>
//                         </Box>

//                         <Grid item xs={12} sm={6}>
//                             <Typography sx={labelStyle}>{words["ID Number"]}*</Typography>
//                             <TextField
//                                 fullWidth
//                                 name="idNumber"
//                                 value={formValues.idNumber}
//                                 onChange={handleInputChange}
//                                 required
//                             />
//                         </Grid>

//                     </Grid>

//                     {/* Form Fields */}
//                     <Grid item xs={12} sm={12}>
//                         <Grid container spacing={2}>

//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle}>{words["License Number"]}*</Typography>
//                                 <TextField
//                                     fullWidth
//                                     name="licenseNumber"
//                                     value={formValues.licenseNumber}
//                                     onChange={handleInputChange}
//                                     required
//                                 />


//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle}>{words["Full Name"]}*</Typography>
//                                 <TextField
//                                     fullWidth
//                                     name="fullName"
//                                     value={formValues.fullName}
//                                     onChange={handleInputChange}
//                                     required
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle}>{words["Address/City"]}*</Typography>
//                                 <TextField
//                                     fullWidth
//                                     name="address"
//                                     value={formValues.address}
//                                     onChange={handleInputChange}
//                                     required
//                                 />

//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle}>{words["Phone"]}*</Typography>
//                                 <TextField
//                                     fullWidth
//                                     name="phone"
//                                     value={formValues.phone}
//                                     onChange={handleInputChange}
//                                     required
//                                 />


//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle}>{words["Email"]}*</Typography>
//                                 <TextField
//                                     fullWidth
//                                     name="email"
//                                     value={formValues.email}
//                                     onChange={handleInputChange}
//                                     required
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Typography sx={labelStyle} >{words["Client type"]}</Typography>
//                                 <RadioGroup
//                                     row
//                                     value={clientType}
//                                     onChange={(e) => setClientType(e.target.value)}
//                                     sx={{ display: 'flex', gap: 2 }}
//                                 >
//                                     <FormControlLabel sx={{ fontFamily: 'PMe', color: colors.dimText, fontSize: 14 }} value="Individual" control={<Radio />} label={words["Individual"]} />
//                                     <FormControlLabel sx={{ fontFamily: 'PMe', color: colors.dimText, fontSize: 14 }} value="Company" control={<Radio />} label={words["Company"]} />
//                                 </RadioGroup>
//                             </Grid>
//                         </Grid>
//                     </Grid>

//                     {/* File Upload */}
//                     <Grid item xs={12}>
//                         <Paper
//                             variant="outlined"
//                             sx={{
//                                 p: 2,
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 borderRadius: '8px',
//                                 backgroundColor: '#f9f9f9',
//                             }}
//                         >
//                             <UploadFile fontSize="large" sx={{ color: '#999', mr: 1 }} />
//                             <Box>
//                                 <Typography sx={{ fontFamily: 'PMe', color: colors.dimText, fontSize: 14 }} >
//                                     {words["Upload Files"]}
//                                 </Typography>
//                                 <Typography sx={{ fontFamily: 'PRe', color: colors.dimText, fontSize: 12 }} >
//                                     PDF, DOC, PPT, JPG, PNG
//                                 </Typography>
//                             </Box>
//                         </Paper>
//                     </Grid>
//                 </Grid>
//             </DialogContent>
//             <DialogActions>

//                 <Button
//                     // onClick={resetCanvas}
//                     variant="outlined"
//                     sx={{
//                         borderRadius: '20px',
//                         fontSize: 12,
//                         padding: '8px 16px',
//                         borderColor: colors.primary,
//                         color: colors.textPrimary,
//                         fontFamily: 'PMe',
//                         textTransform: 'none',
//                         marginRight: 1
//                     }}
//                 >
//                     {words["Cancel"]}
//                 </Button>
//                 <Button
//                     onClick={onClose}
//                     variant="contained" sx={{
//                         backgroundColor: colors.primary,
//                         fontSize: 12,
//                         color: 'white',
//                         fontFamily: 'PMe',
//                         borderRadius: '20px',
//                         padding: '8px 26px',
//                         textTransform: 'none',
//                     }}
//                 >
//                     {words["Submit"]}
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default AddCustomerDialog;
